package com.example.crashbit

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import androidx.compose.runtime.key
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.example.crashbit.data.PreferenceManager
import com.example.crashbit.data.UniverseRepository

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Typography
import androidx.compose.ui.text.font.FontFamily

val CjkFallbackFontFamily = FontFamily.SansSerif

val AppTypography = Typography(
    displayLarge = Typography().displayLarge.copy(fontFamily = CjkFallbackFontFamily),
    displayMedium = Typography().displayMedium.copy(fontFamily = CjkFallbackFontFamily),
    displaySmall = Typography().displaySmall.copy(fontFamily = CjkFallbackFontFamily),
    headlineLarge = Typography().headlineLarge.copy(fontFamily = CjkFallbackFontFamily),
    headlineMedium = Typography().headlineMedium.copy(fontFamily = CjkFallbackFontFamily),
    headlineSmall = Typography().headlineSmall.copy(fontFamily = CjkFallbackFontFamily),
    titleLarge = Typography().titleLarge.copy(fontFamily = CjkFallbackFontFamily),
    titleMedium = Typography().titleMedium.copy(fontFamily = CjkFallbackFontFamily),
    titleSmall = Typography().titleSmall.copy(fontFamily = CjkFallbackFontFamily),
    bodyLarge = Typography().bodyLarge.copy(fontFamily = CjkFallbackFontFamily),
    bodyMedium = Typography().bodyMedium.copy(fontFamily = CjkFallbackFontFamily),
    bodySmall = Typography().bodySmall.copy(fontFamily = CjkFallbackFontFamily),
    labelLarge = Typography().labelLarge.copy(fontFamily = CjkFallbackFontFamily),
    labelMedium = Typography().labelMedium.copy(fontFamily = CjkFallbackFontFamily),
    labelSmall = Typography().labelSmall.copy(fontFamily = CjkFallbackFontFamily)
)

@Composable
fun CrashBitApp(
    preferenceManager: PreferenceManager? = null,
    repository: UniverseRepository? = null,
    hapticFeedback: HapticFeedback? = null,
    onViewModelCreated: ((SpaceViewModel) -> Unit)? = null
) {
    val viewModel: SpaceViewModel = remember {
        SpaceViewModel(preferenceManager, repository, hapticFeedback).also {
            onViewModelCreated?.invoke(it)
        }
    }

    key(viewModel.languageCode) {
        LocalizedApp(viewModel.languageCode) {
            MaterialTheme(typography = AppTypography) {
                Surface(
                    modifier = Modifier.fillMaxSize(),
                    color = Color.Black
                ) {
                    when (viewModel.currentScreen) {
                        is Screen.Onboarding -> LanguageSelectionScreen(viewModel)
                        is Screen.Title -> TitleScreen(viewModel)
                        is Screen.About -> AboutGameScreen(viewModel)
                        is Screen.Browser -> UniverseBrowserScreen(viewModel)
                        is Screen.Sandbox -> SpaceSandbox(viewModel)
                    }
                }
            }
        }
    }
}
